







import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class AppDecimalNumber extends Vue {
  @Prop() inputValue
  @Prop({ default: 2 }) decimal?: number
  @Prop({ default: false }) disabled?: boolean

   inputModal = ''
   textIsSelected = false
   valueChange = false

   numberAndDecimalOnly (evt) {
     evt = (evt) || window.event
     const keyCode = (evt.which) ? evt.which : evt.keyCode

     const currentValue = evt.target.value
     this.valueChange = true
     if (this.textIsSelected) {
       if (this.isNonNumberAndNonDecimal(keyCode)) {
         evt.preventDefault()
       } else {
         this.textIsSelected = false
       }
       return true
     }

     if (this.isNonNumberAndNonDecimal(keyCode)) {
       evt.preventDefault()
     }

     if (this.isDecimal(keyCode)) {
       if (!this.allowDecimal) {
         evt.preventDefault()
       }
       if (currentValue.indexOf('.') >= 0) {
         evt.preventDefault() // cannot key in more than 1 decimal
       }
     }

     if (this.decimal) { // constraint to decimal length that can enter
       const number = currentValue.split('.')
       let caratPos = currentValue.length
       if (evt.srcElement.selectionStart || evt.srcElement.selectionStart === '0') {
         caratPos = evt.srcElement.selectionStart
       }
       const dotPos = currentValue.indexOf('.')
       if (caratPos > dotPos && dotPos > -1 && number[1].length > this.decimal - 1) {
         evt.preventDefault()
       }
     }
   }

   triggerKeyEvent () {
     this.valueChange = true
   }

   get allowDecimal () {
     return this.decimal !== 0
   }

   isNonNumberAndNonDecimal (keyCode) {
     if (!this.allowDecimal) return this.isNonNumber(keyCode)
     return this.isNonNumber(keyCode) && (this.allowDecimal && !this.isDecimal(keyCode))
   }

   isDecimal (keyCode) {
     return keyCode === 46
   }

   isNonNumber (keyCode) {
     // not number and not decimal
     return keyCode > 31 && (keyCode < 48 || keyCode > 57)
   }

   onBlur () {
     if (!this.valueChange && !this.inputModal) { // if user only tap on and tap out the empty field and no edit anything
       this.inputModal = this.formatValue(undefined)
       return // no need emit value as there is no value, so that undefined is saved
     }

     this.inputModal = this.formatValue(this.inputModal)
     this.$emit('input', this.formatValue(this.inputModal, 'num')) // should convert to number type when return back
   }

   onFocus () {
     // convert string to number
     this.valueChange = false
     this.inputModal = this.inputModal.replaceAll(',', '')
   }

   onSelect () {
     this.textIsSelected = true
     this.valueChange = false
   }

   formatValue (source, convertTo: 'str' | 'num' = 'str') {
     if (typeof source === 'string') {
       if (source) {
         source = Number(source.replaceAll(',', ''))
       } else if (source === '' && this.valueChange) {
         source = 0 // so that when clear value, it is auto set to 0
       }
     } else if (source === undefined || source == null) {
       source = ''
     }

     if (convertTo === 'str') {
       if (source === '') return source
       const formatter = new Intl.NumberFormat('en-US', {
         minimumFractionDigits: this.decimal ?? 0,
         maximumFractionDigits: this.decimal ?? 8
       })
       return formatter.format(source)
     }

     if (!source) {
       return 0
     }

     return source
   }

  @Watch('inputValue')
   inputValueOnChange () {
     if (this.inputValue) {
       this.inputModal = this.formatValue(this.inputValue)
     } else {
       this.inputModal = this.formatValue('')
     }
   }

  mounted () {
    this.inputModal = this.formatValue(this.inputValue)
  }
}
